{
    "translation": {
        "test": "texto prueba es"
    }
}
